import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { listAgents } from '../../../helpers/agents';

export default function useAgentList() {
  const hasAutoSelected = useRef(false);

  const [agents, setAgents] = useState([]);
  const [agentsLoading, setAgentsLoading] = useState(false);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const [creatingNewAgent, setCreatingNewAgent] = useState(false);

  const [deleteAllConfirmOpen, setDeleteAllConfirmOpen] = useState(false);
  const [deletingAll, setDeletingAll] = useState(false);
  const [deleteAgentConfirmId, setDeleteAgentConfirmId] = useState(null);
  const [deletingAgent, setDeletingAgent] = useState(false);

  const loadAgents = useCallback(async () => {
    setAgentsLoading(true);
    try {
      const response = await listAgents();
      setAgents(response.data || []);
    } catch {
      toast.error('Failed to load agents');
    } finally {
      setAgentsLoading(false);
    }
  }, []);

  useEffect(() => { loadAgents(); }, [loadAgents]);

  // On mount, open new agent creation instead of auto-selecting existing
  useEffect(() => {
    if (!hasAutoSelected.current && !selectedAgentId && !creatingNewAgent) {
      hasAutoSelected.current = true;
      setCreatingNewAgent(true);
    }
  }, [selectedAgentId, creatingNewAgent]);

  return {
    agents,
    setAgents,
    agentsLoading,
    selectedAgentId,
    setSelectedAgentId,
    creatingNewAgent,
    setCreatingNewAgent,
    loadAgents,
    deleteAllConfirmOpen,
    setDeleteAllConfirmOpen,
    deletingAll,
    setDeletingAll,
    deleteAgentConfirmId,
    setDeleteAgentConfirmId,
    deletingAgent,
    setDeletingAgent,
  };
}
